<template>
    <main>
        <header class="contact">
            <div class="container">
                <h1><br>Do you have any doubt?<br></h1>
                <h4>Contact us!</h4>
            </div>
            <div class="overlay-green-dark"></div>
        </header>

        <section class="contact-area">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 offset-md-1" style="text-align: center;">
                        <h3>Talk to us!</h3>
                        <p class="subheading-text">We want to hear you! Count on us to take the next step in your business.</p>
                        <h5>Phone</h5>
                        <p>{{ info.phone}}</p>
                        <h5>E-mail</h5>
                        <p>{{ info.email }}</p>
                        <h5>Address</h5>
                        <p>{{ info.address.street }}<br>{{ info.address.city }}</p>
                        <h5>Social Networks</h5>
                        <div class="text-center social-media-links">
                            
                            <a :href="info.linkedin_link" target="_blank" class="social-button-circle">
                                <i class="fab fa-linkedin-in"></i>
                            </a>
                        </div>
                        <iframe :src=info.address.mapUrl></iframe>
                        <hr class="mobile" />
                    </div>
                 <!--   <div class="col-md-4 offset-md-2">
                        <h3>Send us a message:</h3>
                        <p class="subheading-text">Preencha o formulário com os seus dados e um integrante de nossa equipe entrará em contato para identificar melhor as suas necessidades.</p>
                        <form v-on:submit.prevent="onSubmit" id="form">
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="NOME*:" id="name">
                            </div>
                            <div class="form-group">
                                <input type="email" class="form-control" placeholder="E-MAIL*:" id="email">
                            </div>
                            <div class="form-group">
                                <input type="phone" class="form-control" placeholder="TELEFONE:" id="phone">
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" placeholder="ASSUNTO*:" id="subject">
                            </div>
                            <div class="form-group">
                                <textarea class="form-control" placeholder="MENSAGEM*:" rows="5" id="message"></textarea>
                            </div>
                            <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="data.contact.msgForm === 'success'">
                                <strong>Sucesso!</strong> Sua mensagem foi enviada, aguarde nosso retorno.
                            </div>
                            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="data.contact.msgForm === 'error'">
                                <strong>Ops...</strong> Não foi possível enviar a mensagem agora, tente novamente.
                            </div>
                            <button type="submit" class="btn btn-viitra-dark float-right">Enviar</button>
                        </form>
                    </div> -->
                </div>
            </div>
        </section>

        <blog-carousel></blog-carousel>
    </main>
</template>

<script>
    export default {
        methods: {
            onSubmit() {
                this.data.contact.msgForm = undefined;
                const body =  {
                    name: $('#name').val(),
                    subject: $('#subject').val(),
                    email: $('#email').val(),
                    phone: $('#phone').val(),
                    message: $('#message').val()
                }
                this.$http.post('/vt-admin/contato', body).then(function (res) {
                    this.data.contact.msgForm = 'success'
                    $('#form').reset();
                }, function(err) { this.data.contact.msgForm = 'error' })
            }
        },
        props: ['info'],
        data(){
            return {
                data: {
                    title: '',
                    description: '',
                    contact: {
                        msgForm: undefined
                    }
                }
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/Contact.vue